module.exports = __webpack_public_path__ + "static/media/ext-prefs.d3f3d401.png";


//////////////////
// WEBPACK FOOTER
// ./src/About/ext-prefs.png
// module id = 776
// module chunks = 0